import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { LoadingScreen, UserHover } from "Components";
import { CreateGroup } from "./CreateGroup";
import { newAuthService } from "Service/Axios";
import { deleteAdminGroupUrl } from "Constant/api";
import { useGroupList } from "Constant/apiHooks";
import { convertLinkObjectListToJoin, getFirstLetterOfName } from "Utils";
import { OverlayTrigger, Popover } from "react-bootstrap";

export const Groups = () => {
  const { t } = useTranslation();
  const [showCreateGroup, setShowCreateGroup] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState(null);

  const { groupList, loading, fetchGroupList } = useGroupList();

  const toggleCreateGroup = (group) => {
    setShowCreateGroup(!showCreateGroup);
    setSelectedGroup(group || null);
  };

  const onDeleteGroup = async (gid) => {
    try {
      const data = {
        gid,
      };
      const response = await newAuthService(deleteAdminGroupUrl, "POST", data);
      if (response.status) {
        fetchGroupList();
        toast.success(t("common.messages.notification.success.deleteGroup"));
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      toast.error(t("common.messages.notification.failed.somethingWentWrong"));
    }
  };

  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <h4 className="admin-sub-title">{t("common.button.groups")}</h4>
        <div className="ms-auto">
          <button
            className="btn btn-primary"
            type="button"
            onClick={() => toggleCreateGroup()}
          >
            <i className="bx bx-plus"></i> {t("common.button.createGroup")}
          </button>
        </div>
      </div>

      <div className="table-container mb-4 max-h-700">
        <table className="table table-bordered">
          <thead className="table-light position-sticky top-0 z-20">
            <tr>
              <th>Name</th>
              <th>Group ID</th>
              <th>Users</th>
              <th>Roles</th>
              <th>Attributes</th>
              <th>Form Folder</th>
              <th>Email Template</th>
              <th>Email Rules</th>
              <th className="text-center">{t("common.label.action")}</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr className="loading-screen">
                <td colSpan={9}>
                  <LoadingScreen />
                </td>
              </tr>
            ) : groupList && groupList.length > 0 ? (
              groupList.map((group) => (
                <tr key={group.gid}>
                  <td>{group.name}</td>
                  <td>{group.groupId}</td>
                  <td>
                    <div className="position-relative d-flex">
                      {group.users &&
                        group.users.length > 0 &&
                        group.users.slice(0, 2).map((user, index) => (
                          <div
                            className="assignee_img applicant-dropdown roles-img"
                            key={`${user.firstName}${index}`}
                          >
                            <OverlayTrigger
                              placement="right"
                              overlay={
                                <Popover className="max-w-unset">
                                  <UserHover user={user} />
                                </Popover>
                              }
                            >
                              <div className="d-flex align-items-center">
                                <div className="w-8 h-8 rounded-circle overflow-hidden">
                                  {user.photoURL ? (
                                    <div className="img-box w-100 h-100">
                                      <img
                                        src={user.photoURL}
                                        alt={`${user.firstName} ${user.lastName}`}
                                        className="w-100 h-100 object-fit-cover"
                                      />
                                    </div>
                                  ) : (
                                    getFirstLetterOfName(user)
                                  )}
                                </div>
                              </div>
                            </OverlayTrigger>
                          </div>
                        ))}
                    </div>
                  </td>
                  <td>{convertLinkObjectListToJoin(group.roles)}</td>
                  <td>{convertLinkObjectListToJoin(group.attributes)}</td>
                  <td>{convertLinkObjectListToJoin(group.formfolders)}</td>
                  <td>{convertLinkObjectListToJoin(group.emailtemplates)}</td>
                  <td>{convertLinkObjectListToJoin(group.emailrules)}</td>
                  <td>
                    <>
                      <div className="d-flex justify-content-center align-items-center gap-1">
                        <button
                          type="button"
                          className="button edit btn btn-transparent px-1 text-green-500"
                          onClick={() => toggleCreateGroup(group)}
                        >
                          <i className="bx bxs-pencil"></i>
                        </button>
                        <button
                          type="button"
                          className="button delete btn btn-transparent px-1 text-red-500"
                          onClick={() => onDeleteGroup(group.gid)}
                        >
                          <i className="bx bx-trash"></i>
                        </button>
                      </div>
                    </>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={9} height={278.8} className="text-center">
                  <h5>{t("common.messages.error.notFound.noDataFound")}</h5>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {showCreateGroup && (
        <CreateGroup
          show={showCreateGroup}
          toggle={toggleCreateGroup}
          selectedData={selectedGroup}
          fetchList={fetchGroupList}
        />
      )}
    </div>
  );
};
